<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>

<script setup lang="ts">
import { useSeoStore } from "~/stores/seo/seo";
import { useCitiesStore } from "~/stores/cities/cities";
import { useLogosStore } from "~/stores/logos/logos";
import { useServicesStore } from "~/stores/services/services";
import { useDocumentsStore } from "~/stores/documents/documents";
import { useLocalesStore } from "~/stores/locales/locales";

await useAsyncData('seo-data', () => useSeoStore().fetchSeo());
await useAsyncData('cities-data', () => useCitiesStore().fetchCities());
await useAsyncData('logos-data', () => useLogosStore().fetchLogos());
await useAsyncData('services-data', () => useServicesStore().fetchServices());
await useAsyncData('documents-data', () => useDocumentsStore().fetchDocuments());
await useAsyncData('locales-data', () => useDocumentsStore().fetchDocuments());

useLocalesStore().initLocale();

await useCitiesStore().initActiveCity();
</script>
